import { createSelector } from 'reselect';

export const initialState = {};

const schedulesSelector = (state = initialState) => state.schedules;

export const getSchedules = createSelector(schedulesSelector, (schedules) => schedules);

export const getSchedulesFromExternal = createSelector(schedulesSelector, (schedules) => {
  if (!schedules || !schedules.externalSchedules) return []
  return schedules.externalSchedules.data.collection
});

export const getSchedulesCollection = createSelector([getSchedules], (schedules) => {
  return schedules.properties;
});
export const getFixAndFlipProps = createSelector([getSchedulesFromExternal], (schedules) => {
  return schedules && schedules.fixflip ? schedules.fixflip : [];
});
const groupEnum = {
  'bridge': 'fix_and_flips',
  'rental': 'investment_properties_owned',
  'primary': 'primary_residence',
}
const Group = (_, group) => groupEnum[group];
export const getSchedulesCollectionByGroup = createSelector([getSchedules, Group], (schedules, group) => {
  return schedules.properties && schedules.properties.filter((property) => property.group === group);
});
export const getSchedulesFromExternalByGroup = createSelector([getSchedulesFromExternal, Group], (schedules, group) => {
  if (!schedules || !schedules.properties) return [];
  return schedules.properties && schedules.properties.filter((property) => property.group === group);
});
export const isAtLeastOneAvailableToDeleteByGroup = createSelector([getSchedules, Group], (schedules, group) => {
  return (
    schedules.properties &&
    schedules.properties.filter((property) => property.group === group && property.meta.availableToDestroy)
  );
});
